import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserNavigationState {
  tab: string | null;
}

const initialState: UserNavigationState = {
  tab: null,
};

const userNavigationSlice = createSlice({
  name: "userNavigation",
  initialState,
  reducers: {
    setUserTab: (state, action: PayloadAction<string>) => {
      state.tab = action.payload;
    },
  },
});

export const { setUserTab } = userNavigationSlice.actions;
export default userNavigationSlice.reducer;
